"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timestampToLocalTimeString = exports.parseUnixOrIsoDate = void 0;
/**
 * Parse a unix epoch value or ISO-ish date string into a Date.
 *
 * - Finite numbers (and all-digit strings) are treated as unix epoch in
 *   {@link ParseUnixOrIsoDateOptions.numericUnit}.
 * - Other non-empty strings are passed to the Date constructor.
 */
function parseUnixOrIsoDate(value, options = {}) {
    if (value === undefined || value === null) {
        return null;
    }
    const factor = options.numericUnit === "seconds" ? 1000 : 1;
    if (typeof value === "number") {
        return Number.isFinite(value) ? new Date(value * factor) : null;
    }
    const trimmed = value.trim();
    if (!trimmed) {
        return null;
    }
    if (/^\d+$/.test(trimmed)) {
        const numeric = Number(trimmed);
        return Number.isFinite(numeric) ? new Date(numeric * factor) : null;
    }
    const parsed = new Date(trimmed);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
}
exports.parseUnixOrIsoDate = parseUnixOrIsoDate;
function timestampToLocalTimeString(timestamp, timeZone) {
    // Using Temporal API to convert UTC timestamp to local time string in the specified timezone.
    if (!timeZone) {
        timeZone = "UTC";
    }
    return new Intl.DateTimeFormat("en-US", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        timeZoneName: "short",
        timeZone: timeZone,
    }).format(timestamp);
}
exports.timestampToLocalTimeString = timestampToLocalTimeString;
